/**
 * Returns slider step that makes native <input type="range"> grid include both
 * `min` and `max`. Native input constrains thumb position to `min + k * step`,
 * so if `(max - min)` is not an integer multiple of `preferredStep`, the max
 * thumb gets stuck on last valid grid position (< max).
 *
 * @param {number} min - range minimum
 * @param {number} max - range maximum (must be >= min)
 * @param {number} preferredStep - desired step granularity (default 0.1)
 * @param {number} targetTicks - density when preferredStep doesn't divide (default 100)
 * @returns {number} step that divides (max - min) into integer number of ticks
 */
const calculateSliderStep = (min, max, preferredStep = 0.1, targetTicks = 100) => {
  const range = max - min;
  if (!Number.isFinite(range) || range <= 0) return preferredStep;

  const ticksAtPreferred = range / preferredStep;
  if (Math.abs(ticksAtPreferred - Math.round(ticksAtPreferred)) < 1e-9) {
    return preferredStep;
  }

  return range / targetTicks;
};

module.exports = { calculateSliderStep };
module.exports.calculateSliderStep = calculateSliderStep;
